import React, {useState} from 'react'
import UppyFileSelect from "./components/uppy_file_select";
import DokaEditor from "./components/doka_editor";
import PhotoScissorsEditor from "./components/photo_scissors_editor";
import PixiEditor from "./components/pixi_editor";
import FabricEditor from "./components/fabric_editor";
import FinalImage from "./components/final_image";
import "./photo_booth.scss"

const PhotoBooth = ({tagOwner, photoBoothConfig, locale}) => {
  const [fileData, setFileData] = useState()
  const [editedDokaFile, setEditedDokaFile] = useState()
  const [editedPhotoSciessorsFile, setEditedPhotoSciessorsFile] = useState()
  const [removedBackground, setRemovedBackground] = useState()
  const [editedPixiBackgroundFile, setEditedPixiBackgroundFile] = useState()
  const [editedPixiFile, setEditedPixiFile] = useState()
  const [editedFabricFile, setEditedFabricFile] = useState()
  const [selectedFrame, setSelectedFrame] = useState()

  const shouldSelectBackground = removedBackground && photoBoothConfig.backgrounds.length > 0
  const selectPixiFilter = (!shouldSelectBackground && editedPhotoSciessorsFile) || editedPixiBackgroundFile
  const translationHtmlContent = locale ? `translations.${locale}` : null

  if (!photoBoothConfig) {
    return <div className={"bg-danger text-white text-center p-4 fa-beat"}>
      Photo Booth Config not found!
    </div>
  }

  const onPhotoSciessorsFileEdited = (file, removedBackground) => {
    setEditedPhotoSciessorsFile(file)
    setRemovedBackground(removedBackground)
  }

  const onResetClicked = (resetTo) => {
    return () => {
      // Take care here, javascript switch without break will fall trough to the next case as well,
      // since we always want to remove following/previous steps as well, this is intended.
      // But just be aware of this behavior.
      switch (resetTo) {
        case "start":
          setFileData(undefined)
        case "doka":
          setSelectedFrame(undefined)
          setEditedDokaFile(undefined)
        case "photo_scissors":
          onPhotoSciessorsFileEdited(undefined)
        case "pixi_background":
          setEditedPixiBackgroundFile(undefined)
        case "pixi_filters":
          setEditedPixiFile(undefined)
        case "fabric":
          setEditedFabricFile(undefined)
      }
    }
  }

  if (editedFabricFile) {
    return <FinalImage
      tagOwner={tagOwner}
      translationHtmlContent={translationHtmlContent}
      onResetClicked={onResetClicked("start")}
      onBackClicked={onResetClicked("fabric")}
      editedPhotoScissorsImageBlob={editedPhotoSciessorsFile}
      photoBoothConfig={photoBoothConfig}
      editedFabricImageBlob={editedFabricFile}
      editedPixiImageBlob={editedPixiFile}
      editedDokaImageBlob={editedDokaFile}
      originalFile={fileData}
    />
  } else if (editedPixiFile) {
    return <FabricEditor
      translationHtmlContent={translationHtmlContent}
      onResetClicked={onResetClicked("start")}
      onBackClicked={onResetClicked(selectPixiFilter ? "pixi_filters" : "pixi_background")}
      photoBoothConfig={photoBoothConfig}
      imageBlob={editedPixiFile}
      onFinished={setEditedFabricFile}
    />
  } else if (selectPixiFilter) {
    return <PixiEditor
      translationHtmlContent={translationHtmlContent}
      onResetClicked={onResetClicked("start")}
      onBackClicked={onResetClicked(shouldSelectBackground ? "pixi_background" : "photo_scissors")}
      key={"pixi-filter"}
      removeFrameFromFinalImage={false}
      showBackgrounds={false}
      showFilters={true}
      photoBoothConfig={photoBoothConfig}
      imageBlob={shouldSelectBackground ? editedPixiBackgroundFile : editedPhotoSciessorsFile}
      selectedFrame={selectedFrame}
      onFileEdited={setEditedPixiFile}
    />
  } else if (editedPhotoSciessorsFile && shouldSelectBackground) {
    return <PixiEditor
      translationHtmlContent={translationHtmlContent}
      onResetClicked={onResetClicked("start")}
      onBackClicked={onResetClicked("photo_scissors")}
      key={"pixi-background"}
      removeFrameFromFinalImage={true}
      showBackgrounds={true}
      showFilters={false}
      photoBoothConfig={photoBoothConfig}
      imageBlob={editedPhotoSciessorsFile}
      selectedFrame={selectedFrame}
      onFileEdited={setEditedPixiBackgroundFile}
    />
  } else if (editedDokaFile) {
    return <PhotoScissorsEditor
      translationHtmlContent={translationHtmlContent}
      onResetClicked={onResetClicked("start")}
      onBackClicked={onResetClicked("doka")}
      photoBoothConfig={photoBoothConfig}
      imageBlob={editedDokaFile}
      selectedFrame={selectedFrame}
      onFinished={onPhotoSciessorsFileEdited}
    />
  } else if (fileData) {
    return <DokaEditor
      translationHtmlContent={translationHtmlContent}
      onResetClicked={onResetClicked("start")}
      photoBoothConfig={photoBoothConfig}
      imageBlob={fileData}
      selectedFrame={selectedFrame}
      setSelectedFrame={setSelectedFrame}
      onFileEdited={setEditedDokaFile}
    />
  }

  return <UppyFileSelect
    translationHtmlContent={translationHtmlContent}
    photoBoothConfig={photoBoothConfig}
    onFileSelected={setFileData}
  />
}

export default PhotoBooth